import React from "react";
import MUIDataTable from "mui-datatables";
import {
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";

import axios from 'axios';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Fab from '@material-ui/core/Fab';
import EditIcon from '@material-ui/icons/Edit';
import { Container, Row, Col } from "shards-react";
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import  api from '../components/common/api';

class SyncPending extends React.Component {

   constructor() {
      super();

      this.state = {
        data: '',
        isLoaded: false,
        dialog:{id:'', open:''}
      }
    }

    async componentDidMount() {
      await this.getPendingSync();
    }
   
    getPendingSync(){
     const token = localStorage.getItem('userToken')

     return axios
              .get(api.hansa_pending_sync().index(),{ headers: {"Authorization" : `Bearer ${token}`} })
              .then(res => {
                this.setState({isLoaded: true, data: res.data})
              })
              .catch(err =>{
                this.setState({isLoaded: true, data: [] })
              })
    }

    handleDialog = (e, contact_id) => {
      e.preventDefault();
      var dialog = this.state.dialog
      dialog.open = !dialog.open
      dialog.contact_id = contact_id
      this.setState({dialog})
      if (!dialog.open){
        this.getPendingCuitVerification()
      }
    }

    getMuiTheme = () =>
      createMuiTheme({
        overrides: {
          MuiTableCell: {
           root: {
             padding: '0px 8px 0px 8px',
             fontSize: '0.73rem'
            }
          }
        }
    });      



    render(){
        const components = {
            ExpandButton: function(props) {
                if (props.dataIndex === 3 || props.dataIndex === 4) return <div style={{ width: '24px' }} />;
                return <EditIcon {...props} />;
            },
        };        
       const columns = [
       {
        name: "id",
        label: "Id",
        options: {
         filter: false,
         display: true,
         sort: true,
        }
       },
       {
        name: "model",
        label: "Modelo",
        options: {
         filter: false,
         display: true,
         sort: true,
        }
       },
       {
        name: "model_id",
        label: "ID Modelo",
        options: {
         filter: false,
         display: true,
         sort: true,
        }
       },
       {
        name: "attempts",
        label: "Intentos",
        options: {
         filter: false,
         display: true,
         sort: true,
        }
       },
       {
        name: "data",
        label: "Parametros",
        options: {
         filter: false,
         display: false,
         viewColumns: false,
         sort: true,
        }
       },
       {
        name: "updated_at",
        label: "Ult. Fecha de intento",
        options: {
         filter: false,
         display: true,
         sort: true,
        }
       }   
      ];


    const options = {
      print:false,
      responsive: 'standard',
      selectableRowsOnClick: false,
      expandableRows: true,
      expandableRowsHeader: false,
      expandableRowsOnClick: true,    
      rowsExpanded: [],
      renderExpandableRow: (rowData, rowMeta) => {
        const data = rowData[4]
        const colSpan = rowData.length + 1;
        return (
            <TableRow>
                <TableCell colSpan={colSpan}><p style={{padding: 10, maxWidth: 800, overflow: 'auto', margin: '0 auto'}}>{data}</p></TableCell>
            </TableRow>            
        );
      },
      onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) =>
        console.log(curExpanded, allExpanded, rowsExpanded),        
      download: false,
      rowsPerPage: 10,
      textLabels: {
            toolbar: {
              search: "Buscar",
              viewColumns: "Ver columnas",
              filterTable: "Filtros",   
              downloadCsv: "Exportar XLS",
            },
            body: {
                noMatch: this.state.isLoaded ?
                    'No hay resultados' :
                    <CircularProgress />,
            },
            selectedRows: {
              text: "fila(s) seleccionadas"
            },
            viewColumns: {
              title: "Ver columnas",
            },
            pagination: {
              next: "Siguiente",
              previous: "Anteior",
              rowsPerPage: "Cantidad por página:",
              displayRows: "de",      
            },
            filter: {
              all: "Todos",
              title: "Filtros",
              reset: "Limpiar"
            }
        }
    };

     return(
        <Container fluid className="main-content-container px-4">
             <Dialog
                open={this.state.dialog.open}
                maxWidth='xl'
                onClose={(e)=>this.handleDialog(e, '')}
                fullWidth={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
              <DialogTitle id="alert-dialog-title" onClose={(e)=>this.handleDialog(e, '')}>Verificación CUIT</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                </DialogContentText>
              </DialogContent>
            </Dialog> 
            
            <Row>
              <Col className="p-2">
                {this.state.isLoaded && <div>
                    <MuiThemeProvider theme={this.getMuiTheme()}>
                    <MUIDataTable
                        title="Transacciones sin procesar"
                        data={Object.values(this.state.data)}
                        columns={columns}
                        options={options}
                        components={components}
                    />
                    </MuiThemeProvider>
                </div>
                }   
              </Col>
            </Row>
           </Container>
      );
    }

}

export default SyncPending;   